import axios from "axios";
import { SET_ALERT } from "../alert";

export const SET_RETAIL_PRODUCTS = "SET_RETAIL_PRODUCTS";
export const SET_RETAIL_SALES    = "SET_RETAIL_SALES";
export const SET_RETAIL_MOVEMENTS = "SET_RETAIL_MOVEMENTS";
export const SET_LOADING         = "SET_LOADING_RETAIL";

export default {
  state: {
    products: [],
    sales: [],
    movements: [],
    isLoading: false,
  },
  mutations: {
    [SET_LOADING](state, v) { state.isLoading = v; },
    [SET_RETAIL_PRODUCTS](state, v) { state.products = v; },
    [SET_RETAIL_SALES](state, v) { state.sales = v; },
    [SET_RETAIL_MOVEMENTS](state, v) { state.movements = v; },
  },
  actions: {
    // ── Products ──────────────────────────────────────────
    getRetailProducts({ commit }, filters) {
      if (filters == undefined) filters = "";
      commit(SET_LOADING, true);
      return axios
        .get("api/retail_products?" + filters)
        .then((r) => {
          commit(SET_LOADING, false);
          commit(SET_RETAIL_PRODUCTS, r.data);
        })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data)
            commit(SET_ALERT, { message: e.response.data.message, type: "error" });
        });
    },

    createRetailProduct({ commit, dispatch }, form) {
      commit(SET_LOADING, true);
      return axios
        .post("api/retail_products", form)
        .then(() => {
          commit(SET_LOADING, false);
          commit(SET_ALERT, { message: "Producto creado correctamente", type: "success" });
          dispatch("getRetailProducts");
        })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data) {
            const msg = e.response.data.errors
              ? e.response.data.errors[Object.keys(e.response.data.errors)[0]][0]
              : e.response.data.message;
            commit(SET_ALERT, { message: msg, type: "error" });
          }
        });
    },

    updateRetailProduct({ commit, dispatch }, { form, id }) {
      commit(SET_LOADING, true);
      return axios
        .put("api/retail_products/" + id, form)
        .then(() => {
          commit(SET_LOADING, false);
          commit(SET_ALERT, { message: "Producto actualizado", type: "success" });
          dispatch("getRetailProducts");
        })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data)
            commit(SET_ALERT, { message: e.response.data.message, type: "error" });
        });
    },

    deleteRetailProduct({ commit, dispatch }, id) {
      commit(SET_LOADING, true);
      return axios
        .delete("api/retail_products/" + id)
        .then(() => {
          commit(SET_LOADING, false);
          commit(SET_ALERT, { message: "Producto eliminado", type: "success" });
          dispatch("getRetailProducts");
        })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data)
            commit(SET_ALERT, { message: e.response.data.message, type: "error" });
        });
    },

    adjustRetailStock({ commit, dispatch }, { form, id }) {
      commit(SET_LOADING, true);
      return axios
        .post("api/retail_products/" + id + "/stock", form)
        .then(() => {
          commit(SET_LOADING, false);
          commit(SET_ALERT, { message: "Stock actualizado", type: "success" });
          dispatch("getRetailProducts");
        })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data)
            commit(SET_ALERT, { message: e.response.data.message, type: "error" });
        });
    },

    getRetailMovements({ commit }, id) {
      return axios
        .get("api/retail_products/" + id + "/movements")
        .then((r) => commit(SET_RETAIL_MOVEMENTS, r.data))
        .catch((e) => {
          if (e.response && e.response.data)
            commit(SET_ALERT, { message: e.response.data.message, type: "error" });
        });
    },

    // ── Sales ─────────────────────────────────────────────
    getRetailSales({ commit }, filters) {
      if (filters == undefined) filters = "";
      commit(SET_LOADING, true);
      return axios
        .get("api/retail_sales?" + filters)
        .then((r) => {
          commit(SET_LOADING, false);
          commit(SET_RETAIL_SALES, r.data);
        })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data)
            commit(SET_ALERT, { message: e.response.data.message, type: "error" });
        });
    },

    createRetailSale({ commit }, form) {
      commit(SET_LOADING, true);
      return axios
        .post("api/retail_sales", form)
        .then((r) => {
          commit(SET_LOADING, false);
          commit(SET_ALERT, { message: "Venta registrada correctamente", type: "success" });
          return r.data;
        })
        .catch((e) => {
          commit(SET_LOADING, false);
          if (e.response && e.response.data)
            commit(SET_ALERT, { message: e.response.data.message, type: "error" });
          throw e;
        });
    },

    cancelRetailSale({ commit, dispatch }, id) {
      return axios
        .post("api/retail_sales/" + id + "/cancel")
        .then(() => {
          commit(SET_ALERT, { message: "Venta cancelada", type: "success" });
          dispatch("getRetailSales");
        })
        .catch((e) => {
          if (e.response && e.response.data)
            commit(SET_ALERT, { message: e.response.data.message, type: "error" });
        });
    },
  },
};
